"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DobConfirmationBody = exports.FixedFooterContainer = exports.EqualWidthDateInputWrapper = exports.StyledErrorBanner = exports.ResponsiveDateLabel = exports.ContinueButtonContainer = exports.DateInputContainer = exports.DobLabel = exports.Heading = exports.DobConfirmationContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const banner_1 = __importDefault(require("@kyruus/banner"));
// Styled components for responsive design
exports.DobConfirmationContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    min-height: auto;
  }
`;
exports.Heading = styled_1.default.div `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  letter-spacing: 0px;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.DobLabel = styled_1.default.div `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-style: normal;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
`;
exports.DateInputContainer = styled_1.default.div `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    /* Reserve space for potential error messages to prevent button from shifting */
    min-height: calc(
      64px + ${(0, ui_theme_1.fromTheme)('spacing_large')} + 20px
    ); /* date inputs + margin + error space */
  }
`;
exports.ContinueButtonContainer = styled_1.default.div `
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;

  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    width: 200px;
    padding-left: 0;
    padding-right: 0;
  }

  button {
    width: 100%;
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  }
`;
// Responsive label component for Date of Birth
exports.ResponsiveDateLabel = styled_1.default.span `
  &::after {
    content: ' *';

    @media (max-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium_max')}) {
      content: '';
    }
  }
`;
// Error banner styling (following cancel/reschedule pattern)
exports.StyledErrorBanner = (0, styled_1.default)(banner_1.default) ``;
// Wrapper to make all date inputs equal width
exports.EqualWidthDateInputWrapper = styled_1.default.div `
  .month-input,
  .day-input,
  .year-input {
    width: calc(33.33% - ${(0, ui_theme_1.fromTheme)('spacing_small')}) !important;
  }
`;
// Fixed footer container for the continue button
exports.FixedFooterContainer = styled_1.default.div `
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${(0, ui_theme_1.fromTheme)('color_background')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  width: 100%;
`;
exports.DobConfirmationBody = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
//# sourceMappingURL=styles.js.map